import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ImageEditor from '../common/FormFileds/ImageEditor/ImageEditor.jsx';
import { deleteUserPhoto, uploadUserPhoto } from '../../actions/user';


const UserPhotoEditor = ({ photo, sex, deleteUserPhoto, uploadUserPhoto }) => {
  const [fetching, setFetching] = useState(false);

  const handleDeletePhoto = () => {
    setFetching(true);
    deleteUserPhoto().then(() => setFetching(false));
  };

  const handleChangePhoto = (formData) => {
    setFetching(true);
    uploadUserPhoto(formData).then(() => setFetching(false));
  };

  const sex_prefix = sex || 'male';
  const emptyPlaceholder = `/static/users/images/${sex_prefix}_placeholder.png`;

  return <ImageEditor image={ photo } isFetching={ fetching } fieldName={ 'photo' }
                      onDelete={ handleDeletePhoto } onChange={ handleChangePhoto }
                      emptyPlaceholder={ emptyPlaceholder }
                      entryName={ gettext('фотографию') }/>
};

UserPhotoEditor.PropTypes = {
  photo: PropTypes.string,
  sex: PropTypes.string,
  deleteUserPhoto: PropTypes.func.isRequired,
  uploadUserPhoto: PropTypes.func.isRequired,
}

export default compose(
  connect(null, { deleteUserPhoto, uploadUserPhoto }),
)(UserPhotoEditor);
